var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about-block"},[(_vm.data)?[_c('h2',{staticClass:"about-block__header"},[_vm._v(" "+_vm._s(_vm.data.title)+" ")]),_c('p',{staticClass:"about-block__text"},[_vm._v(" "+_vm._s(_vm.data.text)+" ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }